import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Add from "./add";
import Table from "./table";

/* eslint-disable */
export default function Users(props) {
  const [addGroup, setAddGroup] = useState(0);
  const [type] = useState(props.type);
  const [openModal, setOpenModal] = useState(false);
  const [currentEmailCopy, setCurrentEmailCopy] = useState();
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleAddGroup = () => {
    const refresh = addGroup + 1;
    setAddGroup(refresh);
  };

  const changeGroup = (currentGroupSelected) => {
    setCurrentEmailCopy(currentGroupSelected);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Add openModal={openModal} closeModal={handleCloseModal} onDone={handleAddGroup} />
      <MDBox pb={3} pt={2}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Table onChange={changeGroup} onAdd={handleOpenModal} groupAdded={addGroup} />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
